import React from 'react';
import { GlobeAltIcon } from '@heroicons/react/24/outline';

export default function LanguageSwitcher({ language, setLanguage }) {
  return (
    <div className="relative inline-block text-left">
      <div className="group">
        <button
          type="button"
          className="inline-flex items-center justify-center rounded-md border border-gray-300 bg-white px-3 py-1 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none"
          id="language-menu-button"
          aria-expanded="true"
          aria-haspopup="true"
        >
          <GlobeAltIcon className="h-4 w-4 mr-2" aria-hidden="true" />
          {language === 'en' ? 'English' : '日本語'}
          <svg className="-mr-1 ml-2 h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
            <path fillRule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z" clipRule="evenodd" />
          </svg>
        </button>
        <div className="absolute right-0 z-10 mt-2 w-32 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none hidden group-hover:block">
          <div className="py-1" role="none">
            <button
              onClick={() => setLanguage('en')}
              className={`block w-full px-4 py-2 text-left text-sm ${language === 'en' ? 'bg-gray-100 text-gray-900' : 'text-gray-700 hover:bg-gray-50'}`}
              role="menuitem"
              id="language-menu-item-0"
            >
              English
            </button>
            <button
              onClick={() => setLanguage('ja')}
              className={`block w-full px-4 py-2 text-left text-sm ${language === 'ja' ? 'bg-gray-100 text-gray-900' : 'text-gray-700 hover:bg-gray-50'}`}
              role="menuitem"
              id="language-menu-item-1"
            >
              日本語
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
